/* eslint-disable no-shadow */
export enum ShiftClaimScreens {
  ShiftClaimScreen = 'ShiftClaimScreen',
}
